<template>
  <div id="app">
    <router-view></router-view>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from '@/views/components/FooterBar'

export default {
  components: {
    FooterBar
  }
}
</script>

<style lang="scss">
#app{
  min-width: 1200px;
  background-color: #fff;
}
@media (max-width: 768px){
  #app{
    min-width: 0px;
  }
}
</style>
